module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_change_img03-c0096a112825b0330396c8356517b23a.svg";